import { h, Component } from "preact";
import colorContrast from "color-contrast";
import OrganiserService from "../../services/OrganiserService";
import { css } from "emotion";
import Image from "../../components/Image";

const styles = {
  organiserLogo: css`
    display: none;
    border-right: 4px;
    @media (max-width: 760px) {
      display: block;
      width: 100px;
      height: 100px;
      margin: 0px auto 16px auto;
    }
  `,
  image: css`
    width: 100px;
    height: 100px;
    margin: 0px auto 16px auto;
    display: block;
    border-radius: 50%;
    @media (max-width: 600px) {
      width: 80px;
      height: 80px;
    }
  `
};

const OrganiserBanner = ({ backgroundColor = "#fff", logo, name, website }) => {
  const colorCode = ["#323232", "#FFFFFF"];
  let primaryTextColor;
  colorCode.forEach(color => {
    if (colorContrast(backgroundColor, color) >= 4.5) {
      primaryTextColor = color;
    }
  });

  const customStyles = {
    wrapper: css`
      max-width: 1000px;
      height: 250px;
      background-color: ${backgroundColor};
      position: relative;
      padding-top: 32px;
      padding-bottom: 32px;
      margin-bottom: 24px;
      @media (max-width: 600px) {
        height: 196px;
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
      }
    `,
    heading: css`
      color: ${primaryTextColor};
      text-align: center;
      font-size: 32px;
      margin-bottom: 8px;
      text-transform: capitalize;
      @media (max-width: 760px) {
        font-size: 18px;
      }
    `
  };

  let siteLink = OrganiserService.sanitiseURLs(website);
  return (
    <div className={customStyles.wrapper}>
      {logo ? (
        <Image src={logo} className={styles.image} alt={`${name} Logo`} />
      ) : (
        <div className={styles.organiserLogo} />
      )}
      <h2 className={customStyles.heading}>{name}</h2>
      <a
        href={siteLink}
        style={{
          color: primaryTextColor,
          textAlign: "center",
          display: "block"
        }}
        target="_blank"
      >
        {website}
      </a>
    </div>
  );
};

export default OrganiserBanner;



// WEBPACK FOOTER //
// ./routes/organiser/OrganiserBanner.js